import { createElement } from 'react';

import { financeRoutePaths } from './paths';
import { LegacyFinanceRedirect } from './LegacyFinanceRedirect';

import type { RouteObject } from 'react-router-dom';

/**
 * TRAD-3867 — 인사이트 섹션(10/30 `/finance` → `/insights` — paths.ts).
 * 목록 = 카테고리 칩 + 글 목록(서버) + 관계 지도·표(정적 그림, 프리렌더) · 상세 = backend 콘텐츠 API(계약 v6) — 프리렌더 대상 아님(nginx 색인 가능 셸).
 */
export const financeRoute: RouteObject = {
  path: financeRoutePaths.finance.path,
  async lazy() {
    const Page = await import('@/pages/finance-relations/ListPage');
    return { Component: Page.default };
  },
};

export const financeContentRoute: RouteObject = {
  path: financeRoutePaths.financeContent.path,
  async lazy() {
    const Page = await import('@/pages/finance-content/DetailPage');
    return { Component: Page.default };
  },
};

/** 관계 지도·표 — 정적 그림(프리렌더 · STATIC_ROUTES). */
export const financeRelationsRoute: RouteObject = {
  path: financeRoutePaths.financeRelations.path,
  async lazy() {
    const Page = await import('@/pages/finance-relations/RelationsPage');
    return { Component: Page.default };
  },
};

/** 공유(캡처) 카드 — router.tsx 에서 MainLayout «밖»(RootLayout 직속)에 둔다. */
export const financeShareCardRoute: RouteObject = {
  path: financeRoutePaths.financeShareCard.path,
  async lazy() {
    const Page = await import('@/pages/finance-content/ShareCardPage');
    return { Component: Page.default };
  },
};

/** dev 에만 있던 `/finance`·`/finance/:slug` → `/insights` 같은 자리(쿼리·해시 유지). */
export const legacyFinanceRoutes: RouteObject[] = [
  { path: financeRoutePaths.legacyFinance.path, element: createElement(LegacyFinanceRedirect) },
  { path: financeRoutePaths.legacyFinanceContent.path, element: createElement(LegacyFinanceRedirect) },
];
